import React from 'react';
import { useSelector } from 'react-redux';

import Section from './Section/Section';

import { useSections } from '../../../../FreeformAnalysisForm/FreeformAnalysisFormContext';
import {
  setCurrentSections,
  setNonLaidOutLibraryItems,
  setSectionToScroll,
} from '../../../../FreeformAnalysisForm/FreeformAnalysisFormContextUtils';

import { getReportFormatLayoutState } from '../../../../../../../common/redux/reportFormat/reportFormatSlice';

import {
  /* generateTargetDroppableLocationIds, */ generateTargetDroppableLocationIdsNew,
} from '../../../generateTargetDroppableLocationIds';

import './LeftPanel.scss';

const LeftPanel = ({
  droppableLocations,
  hideExcelCellRangeFormatSwitch = false,
  libraryItemMap,
  onAddNewSection,
  showRightPanel,
}) => {
  const [
    { currentSections = [], nonLaidOutLibraryItems = [] },
    contextDispatch,
  ] = useSections();
  const { activeSectionIndex } = useSelector(getReportFormatLayoutState);

  const handleAddNewSection = () => {
    onAddNewSection();
  };

  const handleRemoveSection = (sectionOrder) => {
    if (currentSections.length === 1) {
      return;
    }
    const sectionToRemove = currentSections.find(
      (s) => s.order === sectionOrder
    );

    const newNonLaidOutLibraryItems = nonLaidOutLibraryItems.concat(
      sectionToRemove.items.map((item) => libraryItemMap[item.id])
    );
    setNonLaidOutLibraryItems(newNonLaidOutLibraryItems, contextDispatch);

    const newSections = currentSections
      .filter((s) => s.order !== sectionOrder)
      .map((s, i) => {
        return {
          ...s,
          order: i + 1,
        };
      });

    setCurrentSections(newSections, contextDispatch);
  };

  const handleMoveSection = (direction, sectionData) => {
    if (currentSections.length === 1) {
      return;
    }
    const auxSections = [...currentSections];
    auxSections.splice(sectionData.order - 1, 1);
    const indexToMove =
      direction === 'up' ? sectionData.order - 2 : sectionData.order;
    auxSections.splice(indexToMove, 0, sectionData);
    const newSections = auxSections.map((s, i) => {
      return { ...s, order: i + 1 };
    });
    setCurrentSections(newSections, contextDispatch);
    setSectionToScroll(indexToMove, contextDispatch);
  };

  return (
    <div className="left-panel" data-testid="left-panel">
      {currentSections.map((section, i, allSections) => {
        const targetDroppableLocationIds =
          generateTargetDroppableLocationIdsNew(section);

        return (
          <Section
            activeSection={activeSectionIndex === i}
            controlsActive={allSections.length > 1}
            droppableLocations={droppableLocations}
            hideExcelCellRangeFormatSwitch={hideExcelCellRangeFormatSwitch}
            key={section.order}
            lastSection={i === currentSections.length - 1}
            libraryItemMap={libraryItemMap}
            onAddSection={handleAddNewSection}
            onMoveSection={handleMoveSection}
            onRemoveSection={handleRemoveSection}
            sectionData={section}
            showRightPanel={showRightPanel}
            targetDroppableLocationIds={targetDroppableLocationIds}
          />
        );
      })}
    </div>
  );
};

export default LeftPanel;
